<template>
  <v-card height="100%" :class="$route.name">
    <v-layout row wrap>
      <v-flex fill-height xs12 md3 class="conversation">
        <messenger-conversations></messenger-conversations>
      </v-flex>
      <v-flex fill-height xs12 md9 class="messages">
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import { MessengerConversations } from '@/components/messenger'
  export default {
    components: {
      MessengerConversations
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../variables"

  .layout {
    height: 100%;
  }

  @media $display-breakpoints.sm-and-down {
    .Messenger .messages { display: none }
    .MessengerMessage .conversation { display: none }
  }
  @media $display-breakpoints.md-and-up {
    .conversation { padding-right: 0; }
    .messages { padding-left: 0; }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Messenger.vue